import React, { useEffect, useState } from 'react';
import LinkService from '../system/LinkService';
import useApiCall from '../system/useApiCall';
import StandardTable from '../common/Component/StandardTable';
import { GridColumns, GridRowsProp } from '@mui/x-data-grid';
import GameControlTO from '../GameGeneral/GameControlTO';
import Typography from '@mui/material/Typography/Typography';

export default function GameControlXmas25Page() {
  const [controlList, setControlList] = useState<GameControlTO[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const apiCall = useApiCall();

  useEffect(() => {
    getCommandAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getCommandAll = () => {
    setIsLoading(true);
    apiCall.get(LinkService.getGameXmas25ControlAll()).then((data) => {
      if (data) {
        const list: GameControlTO[] = data;
        // Backend representation of GameControlXmas25TO has no id. Table needs an id.
        let idCount = 1;
        for (const item of list) {
          item.id = idCount;
          idCount++;
        }
        setControlList(list);
        setIsLoading(false);
      }
    });
  };

  const columns: GridColumns = [
    { field: 'key', headerName: 'Control Name', flex: 3, editable: false },
    { field: 'valueFormatted', headerName: 'Wert (editierbar)', flex: 2, editable: true },
    { field: 'valueType', headerName: 'Typ', flex: 2, editable: false },
    { field: 'description', headerName: 'Beschreibung', flex: 9, editable: false },
  ];

  const rows: GridRowsProp = [...controlList];

  return (
    <div>
      <Typography component='p' variant='caption'>
        Werte mit Doppelklick editieren.
      </Typography>
      <StandardTable
        saveURL={LinkService.postGameXmas25Control()}
        columns={columns}
        rows={rows}
        isLoading={isLoading}
        hideActions
        hideToolbar
      />
    </div>
  );
}
